export class BlEventLog {

    id: number = 0;
    suntekID: string = '';
    jobName: string = '';
    jobId: number = 0;
    blNo: string = '';
    eventName: string = '';
    eventAtUtc: string | null = null;
    eventAt: string | null = null;
    u1Id: string = '';
    u1Date: string | null = null;
  
    constructor(evtName: string, eventAt: string | null = null) {
      if (evtName) {
        this.eventName = evtName;
      }
      if (eventAt !== null) {
        this.eventAt = eventAt;
      }
    }
  }